import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <>
        <div className="Footer">
            <a href="https://github.com/harsh1kashyap"><span>Harshvardhan Jha</span> || Github</a>
        </div>
    </>
  )
}

export default Footer